<template>
  <div class="inner_content">
    <div class="header">
      <div class="box flex" style="align-items=center">
        <el-input placeholder="请选择手机号或名称" size="small"></el-input>
        <el-button type="primary" size="small" @click="getLists"
          >筛选</el-button
        >
      </div>
    </div>
    <div class="bottom">
      <el-table
        :data="listData"
        size="small"
        :header-cell-style="setHeader"
        height="100%"
      >
        <el-table-column label="公司名称" prop="name"></el-table-column>
        <!-- <el-table-column label="会员等级" prop="level"></el-table-column> -->
        <el-table-column label="电话" prop="mobile"></el-table-column>
        <el-table-column
          label="预估金额"
          prop="estimated_amount"
        ></el-table-column>
        <el-table-column label="余额" prop="collect.balance"></el-table-column>
        <el-table-column
          label="消费"
          prop="collect.consume_amount"
        ></el-table-column>
        <el-table-column label="开户时间" prop="create_time"></el-table-column>
        <el-table-column label="审核状态" prop="auth"></el-table-column>
        <el-table-column width="165px" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              slot="reference"
              @click="option(2, scope.row.id)"
              >通过</el-button
            >
            <el-button
              type="text"
              slot="reference"
              @click="option(1, scope.row.id)"
              >拒绝</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
        :total="total_num"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { List, audit } from "@/api/motorcade";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  inject: ["reload"],
  data() {
    return {
      page: "1",
      total_num: 0,
      listData: [],
      dialogFormVisible: false,
      value1: "",
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      }
    };
  },
  mounted() {
    this.getLists();
  },
  methods: {
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    addSlice() {
      this.$router.push({
        path: `adSign`
      });
    },
    option(type, Oid) {
      console.log("type", type);
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: Oid
      };
      if (type == 2) {
        this.$confirm("确定通过吗？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            data.is_auth = type;
            this.optionAudit(data);
          })
          .catch();
      } else {
        this.$confirm("确定拒绝吗？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            data.is_auth = type;
            this.optionAudit(data);
          })
          .catch();
      }
    },
    optionAudit(data) {
      audit(data).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.reload();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    //审核
    getLists() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        is_auth: "0"
      };
      List(data).then(res => {
        if (res.code == 200) {
          this.listData = res.result;
          this.total_num = res.total_num;
          for (var i = 0; i < this.listData.length; i++) {
            switch (this.listData[i].is_auth) {
              case 0:
                this.listData[i].auth = "待审核";
                break;
              case 1:
                this.listData[i].auth = "审核不通过";
                break;
              case 2:
                this.listData[i].auth = "通过";
                break;
            }
          }
        } else {
          this.$message.warning(res.msg);
        }
        console.log("列表", res);
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getLists();
    }
  }
};
</script>
<style lang="scss" scoped>
.inner_content {
  height: 100%;
  background: #fff;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  .header {
    padding-top: 20px;
    margin-bottom: 20px;
    .box {
      width: 330px;
      .title {
        min-width: 50px;
        text-align: right;
      }
      .fixedwidth {
        width: 180px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .bottom {
    flex: 1;
    overflow-y: scroll;
  }
  .page {
    height: 50px;
    display: flex;
    align-items: center;
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
</style>
